import React from "react";
import {Layout} from 'antd';
import {connect} from 'react-redux';
import {SIDE_NAV_WIDTH, SIDE_NAV_DARK, DIR_RTL} from 'constants/ThemeConstant';
import {Redirect, Route, Switch} from "react-router-dom";
import {APP_PREFIX_PATH} from "../../configs/AppConfig";
import {onDirectionChange} from 'redux/actions/Theme';
import Menu from "../../views/app-views/menu";
import Search from "../../views/app-views/search/Search";
import Branches from "../../views/app-views/branches";
import OrderStatus from "../../views/app-views/OrderStatus";
import OrderMode from "../../views/app-views/OrderMode";
import ReviewCart from "views/app-views/reviewCart";
import GridProducts from "../../views/app-views/menu/menu-categories/grid-view/GridProducts";
import SingleProduct from "../../views/app-views/singleProduct";
import EstimatedTime from "../../views/app-views/estimatedTime";
import BranchItem from "../../views/app-views/branches/BranchItem";
import CheckoutProduct from "../../views/app-views/checkoutProduct";
import CheckOutTwo from "../../views/app-views/checkoutProduct/checkOutTwo";
import CheckoutThree from "views/app-views/checkoutProduct/checkOutThree";
import CheckOutFour from "views/app-views/checkoutProduct/checkOutFour";
import CheckOutFive from "views/app-views/checkoutProduct/checkOutFive";

const {Sider} = Layout;

export const SideNav = ({
                            navCollapsed,
                            sideNavTheme,
                            // routeInfo,
                            // hideGroupTitle,
                            // localization = true,
                            direction,
                            // onDirectionChange
                        }) => {
    // const props = {sideNavTheme, routeInfo, hideGroupTitle, localization}

    return (
        <Sider
            className={`${direction === DIR_RTL ? 'side-nav-rtl' : ''} side-nav app-sider ${window.location.href.includes("/app/menu") && window.innerWidth < 992 && "mobileMainPage"} ${sideNavTheme === SIDE_NAV_DARK ? 'side-nav-dark' : ''}`}
            width={SIDE_NAV_WIDTH}
            collapsed={navCollapsed}
        >
            <Switch>
                <Route exact={true} path={`${APP_PREFIX_PATH}/menu`} component={Menu}/>
                <Route exact={true} path={`${APP_PREFIX_PATH}/categories/:id`} component={GridProducts}/>
                <Route exact={true} path={`${APP_PREFIX_PATH}/products/:id`} component={SingleProduct}/>
                <Route path={`${APP_PREFIX_PATH}/order-mode`} component={OrderMode}/>
                <Route path={`${APP_PREFIX_PATH}/search`} component={Search}/>
                <Route path={`${APP_PREFIX_PATH}/branches/:id`} component={BranchItem}/>
                <Route path={`${APP_PREFIX_PATH}/branches`} component={Branches}/>
                <Route path={`${APP_PREFIX_PATH}/order-status`} component={OrderStatus}/>
                <Route path={`${APP_PREFIX_PATH}/review-cart`} component={ReviewCart}/>
                <Route path={`${APP_PREFIX_PATH}/estimated-time`} component={EstimatedTime}/>
                <Route path={`${APP_PREFIX_PATH}/checkOut`} component={CheckoutProduct}/>
                <Route path={`${APP_PREFIX_PATH}/checkOutTwo`} component={CheckOutTwo}/>
                <Route path={`${APP_PREFIX_PATH}/checkOutThree`} component={CheckoutThree}/>
                <Route path={`${APP_PREFIX_PATH}/checkOutFour`} component={CheckOutFour}/>
                <Route path={`${APP_PREFIX_PATH}/check_order`} component={CheckOutFive}/>

                <Redirect to={`${APP_PREFIX_PATH}/menu`}/>
            </Switch>
        </Sider>
    )
}

const mapStateToProps = ({theme}) => {
    const {navCollapsed, sideNavTheme, direction} = theme;
    return {navCollapsed, sideNavTheme, direction}
};

const mapDispatchToProps = {
    onDirectionChange
}

export default connect(mapStateToProps, mapDispatchToProps)(SideNav);
